import React, { FC } from 'react';
import JobChart from './JobChart';
import { CardContent, CardTitle, SummaryCardContainer, TypeTag } from './SummaryCard.style';

interface IProps {
  annotationSet: any;
}

const SummaryCard: FC<IProps> = props => {
  const { annotationSet } = props;
  const url = `/${annotationSet?.icid}`;

  return (
    <SummaryCardContainer href={url} key={annotationSet?.uuid}>
      <CardTitle type={annotationSet?.type}>
        {annotationSet?.name === '' || annotationSet?.name == null
          ? 'No Provided Name'
          : annotationSet?.name}
        <TypeTag type={annotationSet?.type}>{annotationSet?.type}</TypeTag>
      </CardTitle>

      <CardContent>
        <JobChart annotationSet={annotationSet} />
      </CardContent>
    </SummaryCardContainer>
  );
};

export default SummaryCard;
